import {
  Id,
  Identifiable,
  List,
  project,
  ProjectStatus,
  Resource,
  ResourceTypes,
  Role,
  Tag,
  User,
  Zone,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

type Response = {
  uuid: string;
  name: string;
  description: string;
  startTime: string;
  endTime: string;
  createdDate: string;
  keyRank: number;
  tags: string[];
  commentsNbr?: number;
  attachmentsNbr?: number;
  attributes?: { [key: string]: string };
  organizer: {
    uuid: string;
    type: ResourceTypes;
    role?: Identifiable<Role>;
    affiliation: "INTERNAL" | "EXTERNAL" | null;
    name: string;
    profession: string;
    description: string;
    integratedAt: string | null;
    avatarUrl: string;
    createdDate: string;
    invitationAccepted: boolean;
    user: Identifiable<User> | null;
    tags: Tag[];
    deactivated: boolean;
  };
  location?: Identifiable<Resource>;
  participants: {
    uuid: string;
    type: ResourceTypes;
    role?: Identifiable<Role>;
    affiliation: "INTERNAL" | "EXTERNAL" | null;
    name: string;
    profession: string;
    description: string;
    integratedAt: string | null;
    avatarUrl: string;
    createdDate: string;
    invitationAccepted: boolean;
    user: Identifiable<User> | null;
    tags: Tag[];
    deactivated: boolean;
  }[];
  parentActivity: {
    uuid: string;
    name: string;
  };
  project: {
    uuid: string;
    name: string;
    template: boolean;
    zone: Identifiable<Zone>;
    status: Identifiable<ProjectStatus>;
  };
  minStartDate: string;
  maxEndDate: string;
};

function getEvent(httpClient: HttpClient) {
  return (eventId: Id) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/events/${eventId}?projection=eventDetailsProjection`,
        method: HttpMethods.GET,
      })
      .then((event) => ({
        ...event,
        list: event.parentActivity as Identifiable<List>,
        project: {
          ...project,
          ...event.project,
          // @ts-ignore
          isTemplate: event.project.template,
        },
        tags: event.tags.map((name) => ({ name })),
      }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            notFound: "notFound",
          }),
        ),
      );
}

export { getEvent };
